import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const setNotification = id => {
  return axios.post(`/messages/${id}/notification/`);
};
